import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { NgProgressModule } from '@ngx-progressbar/core';
import { NgProgressHttpModule } from '@ngx-progressbar/http';
import { NgProgressRouterModule } from '@ngx-progressbar/router';

@NgModule({
  imports: [
    InfiniteScrollModule,
    FontAwesomeModule,
    ReactiveFormsModule,

    NgProgressModule.withConfig({
      spinnerPosition: 'left',
      color: '#EF1223',
    }),
    NgProgressHttpModule,
    NgProgressRouterModule,
  ],
  exports: [
    FormsModule,
    CommonModule,
    InfiniteScrollModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    NgProgressModule,
    NgProgressHttpModule,
    NgProgressRouterModule,
  ],
})
export class SharedLibsModule {
  static forRoot(): ModuleWithProviders<SharedLibsModule> {
    return {
      ngModule: SharedLibsModule,
    };
  }
}
